
import {gsap, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
export default class PageArchiveProgram {
	constructor() {

		if( document.body.classList.contains('post-type-archive-program') || document.body.classList.contains('tax-program_region') ){

			GlobalVariables.resizeCallbacks.push(this);
			this.resize();
			this.navCursor();

			const cards = document.querySelectorAll('.card-program');
			const filters = document.querySelectorAll('.program-filters .filter');
			filters.forEach( ( item ) => {
				item.addEventListener('click', ( event ) => {
					event.preventDefault();

					filters.forEach(filter => {
						filter.classList.toggle('active', item === filter);
					});

					let status = item.dataset.filter;
					if( status === 'all'  ){
						cards.forEach(card => {
							card.closest('.col-program-card').classList.remove('d-none');
						});
					} else {
						cards.forEach(card => {
							card.closest('.col-program-card').classList.toggle('d-none', card.dataset.status !== status);
						});
					}
				});
			});
		}
	}

	navCursor(){

		document.fonts.ready.then(() => {

			const cursor = document.querySelector('.program-filters-cursor');
			const items = document.querySelectorAll('.program-filters .filter');

			function moveCursor(el) {
				cursor.style.width = `${el.offsetWidth}px`;
				cursor.style.left = `${el.offsetLeft}px`;
			}

			items.forEach((item) => {
				// Déplace le curseur au survol
				item.addEventListener('mouseenter', (e) => {
					moveCursor(e.target);
				});

				// Optionnel : Retour à l'élément "actif" quand on quitte le menu
				item.addEventListener('mouseleave', () => {
					const activeItem = document.querySelector('.program-filters .filter.active');
					if (activeItem) moveCursor(activeItem);
				});
			});

			// Initialisation au chargement (sur l'item actif par défaut)
			const initialActive = document.querySelector('.program-filters .filter.active');
			if (initialActive) moveCursor(initialActive);

		});

	}

	resize(){

		const map = document.querySelector('.archive-program-map');
		let mapWidth = "100%";

		if( window.innerWidth > 992 ){

			const styles = window.getComputedStyle(map);
			const rect = map.getBoundingClientRect();
			mapWidth =document.querySelector('.page-container').clientWidth - parseInt(rect.left) - parseInt(styles.top) + "px";

		}

		map.style.width = mapWidth;
	}

}

